// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24gy0","label":"styles_label__2VJ__"};